import { render, staticRenderFns } from "./AllModules.vue?vue&type=template&id=8f2898be&"
import script from "./AllModules.vue?vue&type=script&lang=js&"
export * from "./AllModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports